import React, { Component } from 'react';

import './GovernancaConselhoEtica.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';

// import OwlCarousel from 'react-owl-carousel2';
// import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
// import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views,
	governanca_content
} from '../../settings';

import {
	Person
} from '../../components/';

class GovernancaConselhoEtica extends Component {

	constructor() {
		super();

        this.images = images;
        this.governanca_content = governanca_content;

        this.state = {
            width: window.innerWidth,
            cardsDiretores: 0,
            lineDiretoresLeft: 0,
            lineDiretoresWidth: 0
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);

        this.scene;
        this.parallaxInstance;
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    prevPersonDiretores() {
    	console.log('prev');
    	if (this.state.cardsDiretores > 0) {
    		this.setState({
    			lineDiretoresLeft: 100 * (this.state.cardsDiretores - 1),
    			lineDiretoresWidth: ((100 / (this.governanca_content.conselheiros_etica.length - 1)) * (this.state.cardsDiretores - 1)) + '%',
    			cardsDiretores: this.state.cardsDiretores - 1
    		});
    	}
    }

    nextPersonDiretores() {
        const { width } = this.state;
        const isMobile = width <= 769;

        const fraction = (isMobile) ? 1 : 2;

    	if (this.state.cardsDiretores < (this.governanca_content.conselheiros_etica.length - fraction)) {
	    	this.setState({
    			lineDiretoresLeft: 100 * (this.state.cardsDiretores + 1),
    			lineDiretoresWidth: ((100 / (this.governanca_content.conselheiros_etica.length - 2)) * (this.state.cardsDiretores + 1)) + '%',
    			cardsDiretores: this.state.cardsDiretores + 1
    		});
	    } else {
	    	this.setState({
    			lineDiretoresLeft: 0,
    			lineDiretoresWidth: (100 / (this.governanca_content.conselheiros_etica.length - 1)) + '%',
    			cardsDiretores: 0
    		});
	    }
    }

    initParallax() {
        this.scene = document.getElementById('scene');
        this.parallaxInstance = new Parallax(this.scene);
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('4.4 Conselho de Ética');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
        // this.initParallax();
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'conselho-etica'
		];


		// Icon Columns - Diretoria
		const options = {
		    items: 1,
		    nav: true,
		    bullets: true,
		    rewind: true
		};

		const iconsHtml = [];
		for (let i = 0; i < this.governanca_content.conselho_etica_1_icons.length; i++) {
			iconsHtml.push(
				<div key={i} className="icon_columns__column">
					<div className="icon">
						<img src={ this.governanca_content.conselho_etica_1_icons[i].image } />
					</div>
					<div className="content">
		    			<p className="text">{ renderHTML(this.governanca_content.conselho_etica_1_icons[i].text) }</p>
					</div>
				</div>
			);
		}

		const iconsHtml2 = [];
		for (let i = 0; i < this.governanca_content.conselho_etica_2_icons.length; i++) {
			iconsHtml2.push(
				<div key={i} className="icon_columns__column">
					<div className="icon">
						<img src={ this.governanca_content.conselho_etica_2_icons[i].image } />
					</div>
					<div className="content">
		    			<p className="text">{ renderHTML(this.governanca_content.conselho_etica_2_icons[i].text) }</p>
					</div>
				</div>
			);
		}


		var outputIconsHtml;
		if (isMobile) {
			outputIconsHtml = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
								    { iconsHtml }
								    { iconsHtml2 }
								</Carousel>;
		} else {
			outputIconsHtml = iconsHtml;
		}

		var outputIconsHtml2;
		if (isMobile) {
			outputIconsHtml2 = 	"";
		} else {
			outputIconsHtml2 = iconsHtml2;
		}



		var cardsDiretoresClass = [ 'component_cards', 'component_cards--'+this.state.cardsDiretores ];
		var lineDiretoresStyle = {
			// transform: 'translateX('+this.state.lineDiretoresLeft+'%)',
			// width: (100 / (this.governanca_content.conselheiros_etica.length - 1)) + '%'	
			width: this.state.lineDiretoresWidth
		};

		const conselheiros_etica = [];
		for (let i = 0; i < this.governanca_content.conselheiros_etica.length; i++) {
			conselheiros_etica.push(
				<Person
					key={i}
					label={ this.governanca_content.conselheiros_etica[i].label }
					name={ this.governanca_content.conselheiros_etica[i].name }
					subtitle={ this.governanca_content.conselheiros_etica[i].subtitle }
					image={ this.governanca_content.conselheiros_etica[i].image } />
			);
		}

		var outputConselheirosHtml;
		if (isMobile) {
			outputConselheirosHtml = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
										    { conselheiros_etica }
										</Carousel>;
		} else {
			outputConselheirosHtml = <div className={ cardsDiretoresClass.join(' ') }>
				        				{ conselheiros_etica }
				        			 </div>
		}


        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>4.4 Conselho de Ética - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>4.4</span> Conselho de Ética</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Governança corporativa</p>
		        			</div>
		        		</header>

		        		<div className="views__content titled_view disclaimer_view responsabilidades__view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<div className="icon_columns row">
						        			{ outputIconsHtml }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content titled_view disclaimer_view responsabilidades__view responsabilidades2__view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
					        			<div className="icon_columns row">
						        			{ outputIconsHtml2 }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content conselho_view row">

			        		<div className="container">
				        		<Swipeable
				        			className="column"
				        			onSwipedRight={ this.prevPersonDiretores.bind(this) }
				        			onSwipedLeft={ this.nextPersonDiretores.bind(this) }>
				        			<Fade bottom>
				        				<h2 className="section_title">Conselho<br />de Ética</h2>
				        			</Fade>

				        			<div className={ cardsDiretoresClass.join(' ') }>
				        				{ conselheiros_etica }
				        			</div>
				        		</Swipeable>
			        		</div>

			        		<div className="nav_persons">
			        			<button className="nav__prev_person" onClick={ this.prevPersonDiretores.bind(this) }></button>

			        			<div className="nav__line">
			        				<span>Conheça nosso Conselho, passe para o lado.</span>
			        				<div className="line"><div style={ lineDiretoresStyle }></div></div>
			        			</div>

			        			<button className="nav__next_person" onClick={ this.nextPersonDiretores.bind(this) }></button>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section views__content--codigo-conduta-title row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
						        		<span className="gri_label visible_mobile"><text>GRI 102-16, 102-17</text></span>
					        			<p className="section_subtitle">Códigos de</p>
					        			<h2 className="section_title">
						        			conduta<br />
						        			<span className="gri_label visible_desk"><text>GRI 102-16, 102-17</text></span>
					        			</h2>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section views__content--codigo-conduta row">

			        		<div className="container">
				        		<div className="column column--half column--padding-right column--border-right">
				        			<Fade bottom>
				        				<h3>Código de Ética ANBIMA</h3>
					        			<p>Voltado aos associados, determina as normas éticas e os padrões de conduta básicos que devem ser observados nas atividades profissionais e no relacionamento com clientes e agentes do mercado. Aborda temas como concorrência leal, utilização de informações privilegiadas e risco de capacidade de liquidação física ou financeira.</p>
				        			</Fade>
				        		</div>

				        		<div className="column column--half column--padding-left">
				        			<Fade bottom>
				        				<h3>Código de Ética e Conduta Profissional </h3>
					        			<p>Destinado aos funcionários, trata de assuntos como políticas corporativas, segurança da informação e investimentos pessoais, citando o uso indevido de informações privilegiadas e conflitos de interesse. Exige atuação íntegra, justa, legal e transparente dos colaboradores, que assinam um termo atestando que estão de acordo com o documento no momento da contratação.</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { GovernancaConselhoEtica };
